export const NAME = 'programs'
export const ITEMS_PER_PAGE = 12
export const NEED_TO_RE_FILTER_STATISTICS = false
